export default __webpack_public_path__ + "static/media/on_0.bb3c273b.mp3";